import { SubType } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';
export interface VehicleSubTypesState extends EntityState<SubType> {}

export const vehicleSubTypesAdapter: EntityAdapter<SubType> = createEntityAdapter<SubType>({
  selectId: (subType: SubType) => subType.id
});

export const initialState: VehicleSubTypesState = vehicleSubTypesAdapter.getInitialState({ loading: true });
export const vehicleSubTypesSelector = createSelector(
  svcDropdownsFeatureSelector,
  (state: any) => state.vehicleSubTypes
);

export const { selectIds, selectEntities, selectAll, selectTotal } = vehicleSubTypesAdapter.getSelectors(
  vehicleSubTypesSelector
);
